export const ENROLLMENT = '/enrollment/' as const
export const ENROLLMENT_UPDATED = `${ENROLLMENT}updated` as const
export const ENROLLMENT_ALL = `${ENROLLMENT}all` as const
export const ENROLLMENT_STATUS = `${ENROLLMENT}status` as const
export const ENROLLMENT_STUDENT_OWN = `${ENROLLMENT}student/own` as const
export const ENROLLMENT_COURSES = `${ENROLLMENT}courses` as const
